import { render, staticRenderFns } from "./SupportActivity.vue?vue&type=template&id=38606c99&"
import script from "./SupportActivity.vue?vue&type=script&lang=js&"
export * from "./SupportActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports